import {
  RichTextField,
  ShowContextProvider,
  Title,
  useEditController,
} from "react-admin";
import { useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";
import { IdChip } from "../../components/IdChip";
import { ProductStatusChip, priceFmt } from "./productMeta";
import { colors } from "../../data/tokens";

const labelSx = {
  fontSize: 11.5,
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: "0.04em",
  color: colors.textMuted,
};

// Visualização do item de cobrança no padrão da leitura de Contatos:
// cabeçalho com nome/ID à esquerda e situação/preço à direita, corpo
// com parcelamento e descrição.
export const ProductShow = (props: any) => {
  const { id } = useParams();
  const controller: any = useEditController({
    resource: "products/crud",
    id,
  });
  const record = controller?.record;

  return (
    <ShowContextProvider value={controller}>
      <Title title="Itens de Cobrança" />
      <PageTopBreadcrumb
        title="Item de Cobrança"
        firstPath="/#/products/crud"
        secondTitle="Visualizando"
        thirdTitle={record?.name}
        actionType="edit"
      />
      {record && (
        <Card sx={{ marginBottom: 3 }}>
          {/* Box em vez de CardContent: o App.css zera o padding de todo
              .MuiCardContent-root com !important */}
          <Box sx={{ padding: { xs: 2.5, md: 4 } }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                flexWrap: "wrap",
              }}
            >
              <Box sx={{ minWidth: 0 }}>
                <Typography
                  noWrap
                  sx={{
                    fontSize: 17,
                    fontWeight: 700,
                    color: colors.primaryDark,
                  }}
                >
                  {record.name || "Sem nome"}
                </Typography>
                <Box sx={{ marginTop: 0.75 }}>
                  <IdChip value={record.id} />
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1.5,
                  marginLeft: "auto",
                }}
              >
                <ProductStatusChip status={record.status} />
                <Typography
                  sx={{
                    fontSize: 22,
                    fontWeight: 700,
                    color: colors.primaryDark,
                    whiteSpace: "nowrap",
                  }}
                >
                  {typeof record.price === "number"
                    ? priceFmt.format(record.price)
                    : "—"}
                </Typography>
              </Box>
            </Box>

            <Divider sx={{ marginY: 2.5 }} />

            <Typography sx={labelSx}>Parcelamento</Typography>
            <Typography sx={{ fontSize: 14.5, marginTop: 0.5 }}>
              {record.maxInstallments
                ? `Em até ${record.maxInstallments}x`
                : "Somente à vista"}
            </Typography>

            <Typography sx={{ ...labelSx, marginTop: 2.5 }}>
              Descrição
            </Typography>
            <Box
              sx={{
                fontSize: 14.5,
                lineHeight: 1.7,
                marginTop: 0.5,
                overflowWrap: "anywhere",
              }}
            >
              <RichTextField
                source="description"
                emptyText="(sem descrição)"
              />
            </Box>
          </Box>
        </Card>
      )}
    </ShowContextProvider>
  );
};
